import { FC } from "react";
import { TFunction, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { metersPerSecondsToKphOrMph } from "refsix-core";
import { RootState } from "../redux/store";

interface SpeedProps {
    speedInMetersPerSecond: number;
    showUnit?: boolean;
}

/**
 * Formats a speed for display. Every speed stat is stored in metres per second,
 * which is not a unit anyone reads a match in, so this is the single place that
 * converts to the referee's chosen km/h or mph.
 */
export function speedString(
    speedInMetersPerSecond: number,
    useImperial: boolean,
    t: TFunction,
    showUnit: boolean = true
) {
    const value = metersPerSecondsToKphOrMph(
        speedInMetersPerSecond,
        useImperial
    );

    if (!showUnit) {
        return `${value}`;
    }

    const units = useImperial
        ? t("general.speedUnit.imperial")
        : t("general.speedUnit.metric");

    return `${value} ${units}`;
}

const Speed: FC<SpeedProps> = ({ speedInMetersPerSecond, showUnit }) => {
    const { t } = useTranslation();
    const { useImperial } = useSelector(
        (root: RootState) => root.settings.settings
    );

    return <>{speedString(speedInMetersPerSecond, useImperial, t, showUnit)}</>;
};

export default Speed;
